export default __webpack_public_path__ + "static/media/CAO.af6ae892.JPG";